import { render, staticRenderFns } from "./dryingRoom.vue?vue&type=template&id=032f5de6"
import script from "./dryingRoom.vue?vue&type=script&lang=js"
export * from "./dryingRoom.vue?vue&type=script&lang=js"
import style0 from "./dryingRoom.vue?vue&type=style&index=0&id=032f5de6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports